import { createSlice } from "@reduxjs/toolkit";
import { fetchHistoryLogsAsync, getChangedByUserListAsync, getModuleListAsync } from "../actions/historyLogsActions";

type Pagination = {
  page: number;
  limit: number;
  count: number;
};
 
type InitialState = {
  historyLogsLoading: boolean;
  historyLogsData: any[]; 
  columnsList: any[];
  moduleList: any[]; 
  changedByList: any[]; 
  historyLogsError: string | null;
  pagination: Pagination;
}; 

const initialState: InitialState = {
  historyLogsLoading: false,
  historyLogsData: [],
  columnsList: [],
  moduleList: [],
  changedByList: [],
  historyLogsError: null,
  pagination: {
    page: 1,
    limit: 10,
    count: 0,
  },
};

const newhistoryLogsSlice = createSlice({
  name: "historyLogsSlice",
  initialState, 
  reducers: {
    resetHistoryLogs: (state) => {
      state.historyLogsData = [];
      state.pagination = {
        page: 1,
        limit: 10,
        count: 0,
      };
      state.historyLogsError = null;
    },

    clearHistoryLogsData: (state) => {
      state.historyLogsData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistoryLogsAsync.pending, (state) => {
        state.historyLogsLoading = true;
        state.historyLogsError = null;
      })
      .addCase(fetchHistoryLogsAsync.fulfilled, (state, action) => {
        state.historyLogsLoading = false;

        state.historyLogsData = action.payload?.results || [];
        state.columnsList = action.payload?.display_labels || [];
        state.pagination = {
          page: action.payload?.page || 1,
          limit: action.payload?.limit || 10,
          count: action.payload?.count || 0,
        };
      })
      .addCase(fetchHistoryLogsAsync.rejected, (state, action) => {
        state.historyLogsLoading = false;
        state.historyLogsError = action.payload as string;
      });

       builder
      .addCase(getModuleListAsync.pending, (state) => {
        state.historyLogsLoading = true;
        state.historyLogsError = null;
      })
      .addCase(getModuleListAsync.fulfilled, (state, action) => {
        state.historyLogsLoading = false;
        state.moduleList = action?.payload || [];
      })
      .addCase(getModuleListAsync.rejected, (state, action) => {
        state.historyLogsLoading = false;
        state.historyLogsError = action.payload as string;
      });
       builder
      .addCase(getChangedByUserListAsync.pending, (state) => {
        state.historyLogsLoading = true;
        state.historyLogsError = null;
      })
      .addCase(getChangedByUserListAsync.fulfilled, (state, action) => {
        state.historyLogsLoading = false;
        state.changedByList = action?.payload || [];
      })
      .addCase(getChangedByUserListAsync.rejected, (state, action) => {
        state.historyLogsLoading = false;
        state.historyLogsError = action.payload as string;
      });
  },
});

export const {
  resetHistoryLogs,
  clearHistoryLogsData, 
} = newhistoryLogsSlice.actions;

export default newhistoryLogsSlice.reducer;
